<template>
  <div v-if="updateAvailable" class="confirm-update-service-worker-box" :class="{'is-mobile': isMobile}">
    {{ $t('alert.updateAvailable') }}
    <div class="update-service-worker-btn" @click="applyUpdate">{{ $t('global.update') }}</div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'confirmUpdateServiceWorker',
  data() {
    return {
      updateAvailable: false,
      reg: null
    };
  },
  computed: {
    ...mapGetters({
      isMobile: 'isMobile'
    })
  },
  mounted() {
    window.addEventListener("sw-update-available", (event) => {
      this.updateAvailable = true
      /*setTimeout(() => {
        this.updateAvailable = false
      }, 50000)*/
    });
  },
  methods: {
    applyUpdate() {
      if (navigator.serviceWorker.waiting) {
        navigator.serviceWorker.waiting.postMessage({ type: "SKIP_WAITING" });
      }

      // وقتی SW فعال شد → ریلود
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        window.location.reload();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/vuexy/variables";

.confirm-update-service-worker-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  position: fixed;
  bottom: 10px;
  right: 10px;
  width: 100%;
  max-width: 300px;
  padding: 10px;
  border-radius: 0.5rem;
  background-color: #f8f8f8;

  &.is-mobile {
    bottom: 60px;
  }

  .update-service-worker-btn {
    cursor: pointer;
    color: $primary;
  }
}
</style>
